/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$accordion-inner-spacing: 20px !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  @include slotted-margins("*:not([slot])");
}

.#{$prefix}accordionitem-content {
  position: relative;
  width: 100%;
  height: 0px;
  color: v(textColor);
  font-family: $font-family-base;
  box-sizing: border-box;
  overflow: hidden;
  visibility: hidden;
  opacity: 0;

  transition-property: all;
  transition-timing-function: $transition-timing-function;
  transition-delay: 0s;
  transition-duration: 300ms;

  &.#{$prefix}overflow-visible {
    overflow: visible;

    .#{$prefix}accordionitem-content-inner {
      overflow: visible;
    }
  }

  &.#{$prefix}active {
    visibility: visible;
    opacity: 1;
  }

  .#{$prefix}accordionitem-content-inner {
    position: relative;
    padding-top: 8px;
    padding-right: #{$accordion-inner-spacing};
    padding-bottom: #{$accordion-inner-spacing};
    padding-left: #{$accordion-inner-spacing};
    overflow: hidden;
    display: block;
  }
}

::slotted(eon-ui-headline) {
  color: v(textColor);
}
